import { render } from "./ForgotForm.vue?vue&type=template&id=26c45407&scoped=true"
import script from "./ForgotForm.vue?vue&type=script&lang=js"
export * from "./ForgotForm.vue?vue&type=script&lang=js"

import "./ForgotForm.vue?vue&type=style&index=0&id=26c45407&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2236819739/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c45407"]])

export default __exports__